export const FileUploadConst =
{
	key: "documents",
	label: "Doküman",
	maxFileSize: "20971520",
	extensions: ["pdf", "pptx", "ppt", "doc", "docx"]
};